import { useQuery } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'

export const strategyKeys = {
  all: ['admin', 'strategies'] as const,
  rows: ['admin', 'strategies', 'rows'] as const,
  options: ['admin', 'strategies', 'options'] as const,
}

export const useStrategies = () => {
  const api = useApi()

  return useQuery({ queryKey: strategyKeys.rows, queryFn: () => api.strategies.getAll() })
}

export const useStrategyOptions = () => {
  const api = useApi()

  return useQuery({ queryKey: strategyKeys.options, queryFn: () => api.strategies.options() })
}
